import { Validators } from "@angular/forms";
import { FormField } from "./form-field.model";

export const CLIENT_FORM: { [key: string]: FormField } = {
    clientId: {
        id: 'clientId',
        type: 'hidden',
        name: 'clientId',
        label: 'ID',
        placeholder: "ID",
        value: 0,
        data: [],
        validators: [],
        errorMessages: {} 
    },
    resellerId: {
        id: 'resellerId',
        type: 'hidden',
        name: 'resellerId',
        label: 'resellerId',
        placeholder: "ID",
        value: '',
        data: [],
        validators: [],
        errorMessages: {} 
    },
    isActive: {
        id: 'isActive',
        type: 'hidden',
        name: 'isActive',
        label: 'Stato',
        placeholder: "Stato",
        value: '',
        data: [],
        validators: [],
        errorMessages: {} 
    },
    businessName: {
        id: 'businessName',
        type: 'text',
        name: 'businessName',
        label: 'Ragione Sociale del cliente',
        placeholder: "Nome del cliente",
        value: '',
        data: [],
        validators: [Validators.required, Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire il nome del cliente.",
            maxlength: "Il nome del cliente può contenere al massimo 50 caratteri."
        }
    },
    email: {    
        id: 'email',
        type: 'email',
        name: 'email',
        label: 'Email del cliente',
        placeholder: "Email del cliente",
        value: '',
        data: [],
        validators: [Validators.required, Validators.email, , Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire l'email del cliente.",
            email: "Inserire un'email valida.",
            maxlength: "L'email del cliente può contenere al massimo 50 caratteri."
        }
    },
    uniqueCode: {
        id: 'uniqueCode',
        type: 'text',
        name: 'uniqueCode',
        label: 'Codice Univoco cliente',
        placeholder: "Codice Univoco Client",
        value: '',
        data: [],
        validators: [Validators.required, Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire il codice univoco del cliente.",
            maxlength: "Il codice univoco del cliente può contenere al massimo 50 caratteri."
        }
    },
    atecoCodeId: {
        id: 'atecoCodeId',
        type: 'ng-select',
        name: 'atecoCodeId',
        label: 'Codice Ateco',
        placeholder: "Codice Ateco",
        value: null,
        data: [],
        validators: [Validators.required, Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire il codice ateco del cliente.",
            maxlength: "Il codice ateco del cliente può contenere al massimo 50 caratteri."
        }   
    },
    address: {
        id: 'address',
        type: 'text',
        name: 'address',
        label: 'Indirizzo',
        placeholder: "Indirizzo",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire l'indirizzo del cliente."
        }
    },
    cityId: {
        id: 'cityId',
        type: 'ng-select',
        name: 'cityId',
        label: 'Città',
        placeholder: "Città",
        value: null,
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire la città del cliente."
        }
    },
    postalCode: {
        id: 'postalCode',
        type: 'text',
        name: 'postalCode',
        label: 'CAP del cliente',
        placeholder: "C.A.P.",
        value: '',
        data: [],
        validators: [Validators.required, Validators.pattern("^[0-9]{5}$")],
        errorMessages: {
            required: "Inserire il C.A.P. del cliente.",
            pattern: "Il C.A.P. deve essere composto da 5 cifre numeriche."
        }
    },
    nationId: {
        id: 'nationId',
        type: 'select',
        name: 'nationId',
        label: 'Nazione del cliente',
        placeholder: "Nazione",
        value: '',
        data: [ ],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire la nazione del cliente."
        }
    },
    pIvaTaxId: {
        id: 'pIvaTaxId',
        type: 'text',
        name: 'pIvaTaxId',
        label: 'P.IVA/TAX ID',
        placeholder: "P.IVA o C.F.",
        value: '',
        data: [],
        validators: [Validators.required, Validators.pattern("^[0-9]+$")],
        errorMessages: {
            required: "Inserire il P.IVA o C.F. del cliente.",
            pattern: "Inserire un P.IVA o C.F. valido."
        }    
    },
    isAutomaticRelease: {
        id: 'isAutomaticRelease',
        type: 'select',
        name: 'isAutomaticRelease',
        label: 'Certificato di rilascio',
        placeholder: "Certificato di rilascio",
        value: '',
        data: [
            { id: true, name: 'Automatico' },
            { id: false, name: 'Manuale' }],
        validators: [Validators.required],
        errorMessages: {
            required: "Inserire il certificato di rilascio del cliente."
        }
    },
    referentName: {
        id: 'referentName',
        type: 'text',
        name: 'referentName',
        label: 'Nome',
        placeholder: "Nome",
        value: '',
        data: [],
        validators: [Validators.required, Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire il nome del referente.",
            maxlength: "Il nome del referente contenere al massimo 50 caratteri."
        }    
    },
    referentSurname: {
        id: 'referentSurname',
        type: 'text',
        name: 'referentSurname',
        label: 'Cognome',
        placeholder: "Cognome",
        value: '',
        data: [],
        validators: [Validators.required, Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire il cognome del referente.",
            maxlength: "Il cognome del referente contenere al massimo 50 caratteri."
        }    
    },
    referentEmail: {
        id: 'referentEmail',
        type: 'email',
        name: 'referentEmail',
        label: 'Email',
        placeholder: "Email",
        value: '',
        data: [],
        validators: [Validators.required, Validators.email, Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire l'email del referente.",
            email: "Inserire un indirizzo email valido.",
            maxlength: "L'email del referente contenere al massimo 50 caratteri."
        } 
    },
    referentFiscalCode: {
        id: 'referentFiscalCode',
        type: 'text',
        name: 'referentFiscalCode',
        label: 'Codice Fiscale',
        placeholder: "Codice Fiscale",
        value: '',
        data: [],
        validators: [Validators.pattern("^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$")],
        errorMessages: {
            pattern: "Inserire un codice fiscale valido."
        },
        toUppercase: true
    },
    referentBirthDate: {
        id: 'referentBirthDate',
        type: 'date',
        name: 'referentBirthDate',
        label: 'Data di nascita del',
        placeholder: "Data di nascita",
        value: '',
        data: [],
        validators: [],
        errorMessages: { }
    },
    referentBirthPlaceId: {
        id: 'referentBirthPlaceId',
        type: 'ng-select',
        name: 'referentBirthPlaceId',
        label: 'Luogo di nascita',
        placeholder: "Luogo di nascita",
        value: null,
        data: [],
        validators: [],
        errorMessages: { }
    },
    referentPostalCode: {
        id: 'referentPostalCode',
        type: 'text',
        name: 'referentPostalCode',
        label: 'CAP referente',
        placeholder: "CAP referente",
        value: '',
        data: [],
        validators: [Validators.pattern("^[0-9]{5}$")],
        errorMessages: {
            pattern: "Il C.A.P. deve essere composto da 5 cifre numeriche."
        }
    },
    referentRole: {
        id: 'referentRole',
        type: 'text',
        name: 'referentRole',
        label: 'Ruolo referente',
        placeholder: "RSPP., Datore di Lavoro, Responsabile Risorse Umane",
        value: '',
        data: [],
        validators: [Validators.maxLength(50)],
        errorMessages: { 
            maxlength: "Il ruolo del referente contenere al massimo 50 caratteri."
        }
    }
}